import { render, staticRenderFns } from "./d2.vue?vue&type=template&id=1c6a30fb&scoped=true&lang=pug"
import script from "./d2.vue?vue&type=script&lang=js"
export * from "./d2.vue?vue&type=script&lang=js"
import style0 from "./d2.vue?vue&type=style&index=0&id=1c6a30fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a30fb",
  null
  
)

export default component.exports